var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCredits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.244,
    height: 26.244,
    viewBox: "0 0 26.244 26.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M23.938,0H2.307A2.309,2.309,0,0,0,0,2.307V23.938a2.309,2.309,0,0,0,2.307,2.307H23.938a2.309,2.309,0,0,0,2.307-2.307V2.307A2.309,2.309,0,0,0,23.938,0ZM4.613,24.707H2.307a.77.77,0,0,1-.769-.769v-.769H4.613Zm0-3.076H1.538V18.556H4.613Zm0-4.613H1.538V13.942H4.613Zm0-4.613H1.538V9.227H4.613Zm0-4.716H1.538V4.613H4.613Zm0-4.613H1.538V2.307a.77.77,0,0,1,.769-.769H4.613Zm15.48,21.631H6.151V13.942H20.093Zm0-12.3H6.151V1.538H20.093Zm4.613,11.533a.77.77,0,0,1-.769.769H21.631V23.169h3.076Zm0-2.307H21.631V18.556h3.076Zm0-4.613H21.631V13.942h3.076Zm0-4.613H21.631V9.227h3.076Zm0-4.716H21.631V4.613h3.076Zm0-4.613H21.631V1.538h2.307a.77.77,0,0,1,.769.769Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCredits);
export default __webpack_public_path__ + "static/media/icon-credits.e3de15dac1d894b10c931972faa83555.svg";
export { ForwardRef as ReactComponent };